import { ReactNode } from 'react'
import { Badge } from '@/components/ui/badge'
import Card from './Card'

interface Props {
  encounter: wowaudit.Encounter
  kills: number
  secondary?: ReactNode
  style?: React.CSSProperties
}

const EncounterCard = ({ encounter, kills, secondary, style }: Props) => {
  return (
    <Card
      className={`flex items-center gap-2 p-0 pr-1 w-36 ${
        kills ? '' : ' opacity-30 grayscale'
      }`}
      style={style}
    >
      <img
        src={encounter.thumbnailUrl}
        alt={encounter.name}
        className='w-12 h-12 rounded-l-md'
      />
      <div className='flex flex-col min-w-0'>
        <span className='truncate'>{encounter.name}</span>
        <div>
          {kills ? (
            <Badge variant='outline' className='h-4'>
              <span>{kills}×</span>
              {secondary ? (
                <span className='ml-2 border-l pl-2 flex items-center'>
                  {secondary}
                </span>
              ) : null}
            </Badge>
          ) : (
            <span className='text-muted-foreground'>-</span>
          )}
        </div>
      </div>
    </Card>
  )
}

export default EncounterCard
